import React from 'react';

import { angularizeWithProviders } from '../../../shared/providers';
import { CustomerInbodyAccountCard } from './CustomerInbodyAccountCard/CustomerInbodyAccountCard';
import { useCustomerInbodyAccounts } from './hooks/useCustomerInbodyAccounts';
import { CUSTOMER_TYPE } from '../../../shared/constants/customer/customerType';

type NgzCustomerInbodyAccountsWidgetProps = { customerId: number } & (
  | { customerType: typeof CUSTOMER_TYPE.SCAN_IQ; entityId: number }
  | { customerType: typeof CUSTOMER_TYPE.NUTRITION; entityId?: number }
);

const NgzCustomerInbodyAccountsWidget = ({
  customerId,
  customerType,
  entityId,
}: NgzCustomerInbodyAccountsWidgetProps) => {
  const {
    inbodyAccounts,
    handleRefreshInbodyAccountData,
    handleRequestInbodyAccountAccess,
  } = useCustomerInbodyAccounts(customerId, customerType, entityId);

  return (
    <>
      {inbodyAccounts.map((inbodyAccount) => (
        <CustomerInbodyAccountCard
          key={inbodyAccount.inbodyKeyId}
          inbodyAccount={inbodyAccount}
          onRefreshInbodyAccountData={handleRefreshInbodyAccountData}
          onRequestInbodyAccountAccess={handleRequestInbodyAccountAccess}
        />
      ))}
    </>
  );
};

angularizeWithProviders(
  NgzCustomerInbodyAccountsWidget,
  'ngzCustomerInbodyAccountsWidget',
  {
    customerId: '<',
    customerType: '@',
  },
);

export { NgzCustomerInbodyAccountsWidget };
